const DEFAULT_RATE = 35;

const toRate = (v) => (typeof v === 'number' && v > 0 ? v : DEFAULT_RATE);

// 평당 — complete × 평 (max 캡)
const perArea = (priceObj, area) => {
  const per = Number(priceObj?.complete) || 0;
  const cap = Number(priceObj?.max) || 0;
  const raw = per * area;
  return cap > 0 ? Math.min(raw, cap) : raw;
};

export const buildContractRevenueRows = (settings, area) => {
  const s = settings || {};
  const industries = Array.isArray(s.industryDefaults) ? s.industryDefaults : [];
  const byKey = Object.fromEntries(industries.map((i) => [i.key, i]));

  const movingRate = toRate(byKey.moving?.completeRate);
  const cleaningRate = toRate(byKey.cleaning?.completeRate);
  const internetRate = toRate(byKey.internet_tv?.completeRate);
  const interiorRate = toRate(byKey.interior?.completeRate);

  const interiorPer = Number(s.interiorPrice?.perPyeong) || Number(s.interiorPrice?.unit) || 0;
  const interiorCap = Number(s.interiorPrice?.max) || 0;
  const interiorRaw = interiorPer * area;
  const interiorTotal = interiorCap > 0 ? Math.min(interiorRaw, interiorCap) : interiorRaw;

  const rows = [
    { name: '포장이사', total: perArea(s.movingTiers?.pack, area), rate: movingRate, isFlat: false },
    { name: '반포장이사', total: perArea(s.movingTiers?.semi_pack, area), rate: movingRate, isFlat: false },
    { name: '일반이사', total: perArea(s.movingTiers?.normal, area), rate: movingRate, isFlat: false },
    { name: '입주청소', total: perArea(s.cleaningPrice, area), rate: cleaningRate, isFlat: false },
    { name: '인터넷 단독', total: Number(s.internetPriceOnly?.complete) || 0, rate: internetRate, isFlat: true },
    { name: '인터넷·TV', total: Number(s.internetPrice?.complete) || 0, rate: internetRate, isFlat: true },
    { name: '인테리어', total: interiorTotal, rate: interiorRate, isFlat: false },
  ];

  const shares = rows.map((r) => Math.round((r.total * r.rate) / 100));
  const totals = rows.map((r) => r.total);
  const maxShare = shares.length ? Math.max(...shares) : 0;
  const maxTotal = totals.length ? Math.max(...totals) : 0;
  const sumShare = shares.reduce((a, b) => a + b, 0);
  const sumTotal = totals.reduce((a, b) => a + b, 0);

  return { rows, totals, shares, maxShare, maxTotal, sumShare, sumTotal };
};
